"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
exports.adoptionNodeSchema = Yup.object()
  .shape({
    templatesToAdopt: Yup.mixed().when("isArray", {
      is: Array.isArray,
      then: Yup.array().of(
        Yup.object().shape({
          ids: Yup.array()
            .of(Yup.string())
            .required(),
          account: Yup.string().required(),
          region: Yup.string().required()
        })
      ),
      otherwise: Yup.string()
    })
  })
  .required();
class AdoptionNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    return helper_1.isValid(
      [
        { schema: exports.adoptionNodeSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() }
      ],
      node.getNodeId()
    );
  }
}
exports.AdoptionNodeValidation = AdoptionNodeValidation;
//# sourceMappingURL=AdoptionNodeValidation.js.map
